<template>
  <div class="project-info-main">
    <el-dialog
    class="modal project-info"
    :title="DialogTitle"
    :visible="DialogVisible"
    :close-on-click-modal="false"
    @close="$emit('close', false)"
    width="610px"
  >
    <div class="dialog-title" slot="title">
      {{DialogTitle}}
    </div>
    <div class="project-info-main">
        <panelTable :tableData="tableData" @configFun="go_router"></panelTable>
        <!-- <div class="el-radio">
            <span class="el-radio__input-span"></span>
            <span class="el-radio__label">
                <span class="radio-span">{{$t('projectInfoPanelTheadPanelNo')}}</span>
                <span class="radio-span center">{{$t('projectPanelMode')}}</span>
                <span class="radio-span center">{{$t('projectInfoPanelTheaddesc')}}</span>
                <span class="radio-span center">{{$t('operation')}}</span>
            </span>
        </div>
        <template v-for="(item,index) in data">
            <el-radio v-model="radio" :label="item" :key="index"> 
              <span class="radio-span">{{item.panelNo}}</span>
              <span class="radio-span center">{{item.isNetWork ? $t('projectPanelTypeNetwork') : $t('projectPanelTypeSingle')}}</span>
              <span class="radio-span center">{{item.descr}}</span>
            </el-radio>
        </template> -->
    </div>
    <!-- <div class="project-info-button">
      <el-button class="gray-btn" @click="$emit('close', false)">{{ $t('cancel') }}</el-button>
      <el-button class="blue-btn" @click="go_router">{{ $t('sure') }}</el-button>
    </div> -->
    </el-dialog>
  </div>
</template>
<script>
import panelTable from '../../components/panelTable.vue'
export default {
    name: 'projectInfo',
    props:{
        DialogVisible: {
           type: Boolean,
           default: false
        },
        data:{
            type: Array,
            default: ()=>{
                return [
                    {id:1,descr:'c蚕丝'}
                ]
            }
        },
        projectName: {
            type: String
        }
    },
    components: {
        panelTable
    },
    data () {
        return {
            DialogTitle: this.$t('projectSelectPanels'),
            radio:'',
            tableData:{
                sel: null,// 选中行 
                row: { panelNo: 0, descr: "", isSet: true,  select_isNetWork: 1 ,panelNo_disabled: false,isNetWork_disabled: true,isAddPanel:true} , //新增行数据
                tHead: [
                { id: "panelNo", name: this.$t('projectInfoPanelTheadPanelNo'), show: true,type: 'input', placeholder: "登录用户", },
                { id: "descr", name: this.$t('projectInfoPanelTheaddesc'), show: true,type: 'input', placeholder: "登录密码", },
                { id: "isNetWork", name: this.$t('projectPanelMode'), show: true,type: 'select', placeholder: "是否组网",options:[
                    {value: 0,label: this.$t('projectPanelTypeSingle')},
                    {value: 1,label: this.$t('projectPanelTypeNetwork')}
                ]},
                ],
                tBody: [
                // { panelNo: 0 , descr: '测试',isNetWork:0, isSet:false, select_isNetWork:0 }
                ],
                addShow: true
            },
        }
    },
    watch:{
        data:{
            handler (v) {
                if(v.length != 0){
                    v.forEach(item => {
                        this.tableData.tBody.push({ panelNo: item.panelNo , 
                            descr: item.descr ,isNetWork: item.isNetWork, isSet:false, 
                            select_isNetWork:item.isNetWork,id:item.id,projectId:item.projectId,isAddPanel:false
                        })
                        this.tableData.addShow = item.isNetWork ? true : false
                    });
                }
            },
            deep: true,
            immediate: true,
        }
    },
    methods:{
        go_router(row){
            console.log(this.tableData,'tableData',row)
            // if(!this.tableData.tBody.length ==0){
            //     this.$message.warning(this.$t('projectInfoPanelsWarning'));
            //     return
            // }
            this.$router.push({path:'/systemSettings',query:{
                panelId:row.id,
                panelNo:row.panelNo,
                projectId:row.projectId,
                projectName: this.projectName
            }})
            this.$emit('close', false);
            this.$parent.$emit('close', false)
        }
    }
}
</script>
<style lang="less" scoped>
.project-info{
    width: 100%;
    height: 100%;
    .project-info-main{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        /deep/ .el-radio{
            width: 520px;
            display: block;
            border-bottom: 1px solid #ccc;
            line-height: 40px;
            padding:0 20px;
            box-sizing: border-box;
            margin: 0 auto;
            .el-radio__input-span{
                display: inline-block;
                width: 14px;
                height: 14px;
            }
            .el-radio__label{
                margin-left: 20px;
            }
            .center{
                margin-left: 20px;
            }
            .radio-span:last-child{
               margin-left: 20px;
               min-width: 100px;
               text-align: center;
               display: inline-block;
            }
        }
    }
    .project-info-button{
        margin-top: 50px;
        text-align: center;
    }
}
</style>